import type { EventName } from "@lit/react";
import { Notification as NotificationElement, type NotificationEventMap as _NotificationEventMap, } from "@vaadin/notification/vaadin-notification.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { NotificationElement, };
export type NotificationEventMap = Readonly<{
    onClosed: EventName<_NotificationEventMap["closed"]>;
    onOpenedChanged: EventName<_NotificationEventMap["opened-changed"]>;
}>;
const events = { onClosed: "closed", onOpenedChanged: "opened-changed" } as NotificationEventMap;
export type NotificationProps = WebComponentProps<NotificationElement, NotificationEventMap>;
export const Notification = createComponent({
    elementClass: NotificationElement, events, react: React, tagName: "vaadin-notification"
});
